// @ts-nocheck

import React, { useMemo } from 'react';
import styled from 'styled-components';

import { MyMatchLongErrorLabels } from '../../constants/mymatch';
import { __ } from '../../i18n/l10n';
import { type MyMatchAPIErrorId } from '../../types/mymatch';
import AdaptativeModal from '../AdaptativeModal';

const Wrapper = styled.div`
  background-color: #14171f;
  color: #c1c9cf;

  padding: 1em;
  border-radius: 0.8em 0em 0.8em 0.8em;
`;

const Header = styled.div`
  font-size: 140%;
  font-weight: bold;
  margin-bottom: 0.5em;
`;

const Text = styled.div``;

type MyMatchErrorModalProps = {
  className?: string;
  show?: boolean;
  onClose: () => void;
  matchMMErrorId: MyMatchAPIErrorId;
};

const MyMatchErrorModal = ({ className = '', show = false, onClose, matchMMErrorId }: MyMatchErrorModalProps) => {
  const errorLabel = useMemo(() => MyMatchLongErrorLabels[matchMMErrorId](), [matchMMErrorId]);

  return matchMMErrorId ? (
    <AdaptativeModal identifier="my-match-error-modal" show={show} onClose={onClose} forbidBackgroundScrolling>
      <Wrapper className={className}>
        <Header>{__('MyMatch mode')}&nbsp;❌</Header>
        <Text>{errorLabel}</Text>
      </Wrapper>
    </AdaptativeModal>
  ) : null;
};

export default MyMatchErrorModal;
